<app-sales-credit-number [creditNumber]="data().number" [data]="data()" *ngIf="categoryCode !== 'kredicash' "></app-sales-credit-number>

<div class="container section__creditResume h-full">
  <div class="wrapper">
    <div class="sectionContainer fadeinright animation-duration-200">
      <article class="pb-40">
        <app-sales-breadcrumbs [routes]="routesBreadcrumb"></app-sales-breadcrumbs>

        <div class="mainInfo">
          <i class="mainIcon mainIcon--resume">
            <app-success-simple-icon></app-success-simple-icon>
          </i>
          <h1>¡El proceso ha finalizado!</h1>
          <p>Retanqueo aprobado exitosamente.</p>
        </div>

        <div class="clientBox pt-30">
          <div class="icon">
            <app-circle-client-icon></app-circle-client-icon>
          </div>
          <div class="info">
            <p><strong>Cliente:</strong> {{ data().person?.first_name.toLowerCase() }} {{ data().person?.last_name.toLowerCase() }}</p>
            <p><strong>Documento:</strong> {{ data().person?.document_id_number }}</p>
          </div>
        </div>

        <div class="resumeBox mt-20">
          <div class="product product--border mb-25">
            <div class="subtitle mb-10">
              <h2>Producto adquirido</h2>
            </div>

            <div class="product__item">
              <div class="productListItem__cont">
                <div class="img">
                  <img src="assets/images/icon-telefono.svg" [alt]="data().product?.name">
                </div>
                <div class="info">
                  <div class="title">
                    <h3>{{data().product?.name}}</h3>
                  </div>
                  <div class="main-price">
                    <p>{{ data().quotes?.prices.selected | currency}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="creditSummary mb-25">
            <div class="creditSummary__title">
              <h2>Resumen de consolidación</h2>
            </div>
            <div class="creditSummary__content">
              <div class="creditSummary__header">
                <i><app-hand-money-simple-icon></app-hand-money-simple-icon></i>
                <h3>Consolidación del crédito</h3>
              </div>

              <div class="creditSummary__items">
                <ul>
                  <li>
                    <div class="item__content">
                      <div div class="title">Crédito anterior</div>
                      <div class="value"><span class="highlight">+ {{ topUpLoan.current_loan.balance ?? 0 | currency }}</span></div>
                    </div>
                  </li>
                  <li>
                    <div class="item__content">
                      <div class="title">Descuento por cancelación anticipada</div>
                      <div class="value">- {{ topUpLoan.consolidation.discount | currency }}</div>
                    </div>
                  </li>
                  <li class="sub">
                    <div class="item__content">
                      <div class="title">Subtotal saldo a consolidar</div>
                      <div class="value">{{ subtotalToConsolidate | currency }}</div>
                    </div>
                  </li>
                  <li>
                    <div class="item__content">
                      <div class="title">Valor financiado — nueva compra</div>
                      <div class="value"><span class="highlight">+ {{ topUpLoan.consolidation.total_new_credit | currency }}</span></div>
                    </div>
                    <div class="item__desc">
                      <p>KrediYA pagará este valor al comercio por esta compra.</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="creditSummary__total">
              <div class="title">Nuevo monto del crédito consolidado</div>
              <div class="value">
                <i><app-circle-money-icon></app-circle-money-icon></i>
                <span>{{ topUpLoan.consolidation.total_financed | currency }}</span>
              </div>
            </div>
          </div>

          <div class="advancePayment mb-25" *ngIf="hasAdvancePayment">
            <div class="advancePayment__title">
              <h2>Anticipo pagado en tienda</h2>
            </div>

            <div class="advancePayment__content">
              <div class="value">
                <h3>Anticipo pagado por el cliente</h3>
                <span>{{ topUpLoan.advance_payment | currency }}</span>
              </div>

              <div class="description">
                <p>Este valor fue abonado por el cliente como anticipo en tienda.</p>
              </div>
            </div>
          </div>

          <div class="creditConditions mb-25">
            <div class="creditConditions__title">
              <h2>Condiciones del crédito</h2>
            </div>

            <div class="creditConditions__content">
              <div class="items">
                <div class="item">
                  <div class="item__content">
                    <div class="content">
                      <h3>Cuota {{ frecuencyTextSingular(topUpLoan.new_loan.frequency) }}</h3>
                      <span class="highlight">{{ topUpLoan.new_loan.quota_amount | currency }}</span>
                    </div>
                  </div>
                </div>

                <div class="item">
                  <div class="item__content">
                    <div class="content">
                      <h3>Primera cuota</h3>
                      <span>{{ topUpLoan.first_payment_date | date:'longDate' }}</span>
                    </div>
                  </div>
                </div>

                <div class="item">
                  <div class="item__content">
                    <div class="content">
                      <h3>Plazo</h3>
                      <span>{{ topUpLoan.new_loan.quota_quantity }} cuotas</span>
                    </div>
                  </div>
                </div>

                <div class="item">
                  <div class="item__content">
                    <div class="content">
                      <h3>Frecuencia</h3>
                      <span>{{ frecuencyTextSingular(topUpLoan.new_loan.frequency) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="creditInfo">
            <div class="title">
              <h2>Importante</h2>
            </div>
            <div class="msgAlert">
              <div class="msgAlert__title">
                <i><app-alert-simple-icon></app-alert-simple-icon></i>
                <h3>Crédito anterior cancelado</h3>
              </div>
              <div class="msgAlert__description">
                <p>El crédito anterior fue cancelado automáticamente. El cliente solo tiene este nuevo crédito consolidado activo.</p>
              </div>
            </div>
          </div>
        </div>
      </article>

      <footer>
        <div class="footer__content flexColumn">
          <!-- <button pButton pRipple label="Descargar PDF" icon="pi pi-download" iconPos="right" class="p-button-secondary p-button-raised p-button-rounded w-full n-background"></button>         -->

          <button pButton pRipple label="Volver al inicio" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onHomePage()" [disabled]="isLoading()"></button>
        </div>
      </footer>
    </div>
  </div>
</div>
